import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function AuthoringHideUnchangedToggle({ hidden, onToggle, dataCy }) {
    const icon = hidden ? "mdi:eye-outline" : "mdi:eye-off-outline"
    const caption = hidden ? "Show all sections" : "Hide unchanged sections"

    return (
        <Button
            size="small"
            variant="text"
            onClick={onToggle}
            startIcon={<Iconify icon={icon} />}
            data-cy={dataCy}
            sx={{ pl: 0 }}
        >
            {caption}
        </Button>
    )
}
